import React from 'react'
import { Table } from 'antd'
import { getFullDate } from "./../util"

export default function Datatable({ data }) {

    console.log({ data })
    const columns = [
        {
            title: "Email",
            dataIndex: "email"
        },
        {
            title: "Name",
            dataIndex: "name"
        },
        {
            title: "Phone",
            dataIndex: "phone",
        },
        {
            title: "Country",
            dataIndex: "country",
        },
        {
            title: "City",
            dataIndex: "city",
        },
        {
            title: "Date",
            dataIndex: "createdAt",
            render: ((date) => getFullDate(date))
        }
    ]
    return (
        <>
            <Table
                dataSource={data}
                columns={columns}
                rowKey={(record => record._id)}
                style={{ overflowY: 'auto', height: '77vh', overflowX: 'hidden' }}

            >

            </Table>
        </>
    )
}

